import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactMuveszetterapiaContent from '@/components/contact/ContactMuveszetterapiaContent'

export default function ContactMuveszetterapia() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Művészetterápia | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés művészetterápiás foglalkozásra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/muveszetterapia" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Művészetterápia) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés művészetterápiás foglalkozásra"
          hidden="muveszetterapia"
          content={<ContactMuveszetterapiaContent />}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            className="mx-auto h-[600px] w-[600px] object-cover"
          >
            <source src={`${config.basePath}/images/muveszetterapia.mp4`} type="video/mp4" />
          </video>
        </Contact>
      </section>
      
      <div className="mx-auto w-3/4 mb-8">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
